import { render, staticRenderFns } from "./NodeDataTabs.vue?vue&type=template&id=905372a4&scoped=true&"
import script from "./NodeDataTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./NodeDataTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NodeDataTabs.vue?vue&type=style&index=0&id=905372a4&prod&scoped=true&lang=css&"
import style1 from "./NodeDataTabs.vue?vue&type=style&index=1&id=905372a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905372a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VIcon,VSkeletonLoader,VTab,VTabItem,VTabs})
